import React, { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { useLocalization } from "../hooks/useLocalization";

export const FileUploader = ({ onUpload, accept = ".pdf,.png,.jpg,.jpeg,.webp,.heic" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const { t } = useLocalization();

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      await onUpload(file);
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div
      className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-blue-400 transition-colors cursor-pointer bg-gray-50"
      onClick={() => inputRef.current?.click()}
      data-testid="file-uploader-dropzone"
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        data-testid="file-uploader-input"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      {uploading ? (
        <Loader2 className="mx-auto mb-2 animate-spin text-blue-600" size={28} />
      ) : (
        <UploadCloud className="mx-auto mb-2 text-blue-500" size={28} />
      )}
      <p className="text-sm font-medium text-gray-600">{uploading ? t("common.loading") : t("documents.uploadDocument")}</p>
    </div>
  );
};
